module.exports = __webpack_public_path__ + "img/13.42614012.jpg";